import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
      <i className="ri-home-4-line text-foreground-500"></i>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}